import type { IOsasReferralData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralSchema';
import { initialAddress } from '@common/validation/address';
import { processActivityInitialMedicationData } from '@common/validation/customControls/processActivityMedicationData';
import { processActivityInitialProfessionalSummaryData } from '@common/validation/customControls/processActivityProfessionalSummaryData';

export const baseComorbidityValues = {
    COPD: false,
    burnoutOrDepressed: false,
    cardialProblems: false,
    diabetesMellitus: false,
    highBloodPressure: false,
    other: null,
};

export const basePhysicalExaminationValues = {
    hasDentures: null,
    isDentitionWellSanitized: null,
    isDentitionWellSanitizedRemark: null,
    retrognathism: null,
    tongueSize: null,
    tonsilSize: null,
};

export const initialData: IOsasReferralData = {
    ...basePhysicalExaminationValues,
    ...processActivityInitialProfessionalSummaryData,
    ...processActivityInitialMedicationData,
    alcoholStoppedSince: null,
    assets: [],
    comorbidities: baseComorbidityValues,
    comorbidityChoice: null,
    daysAWeek: null,
    draftCareProviderOrganizationId: null,
    draftCareProviderPractitionerId: null,
    drugUseStoppedSince: null,
    glassesADay: null,
    importantComplaints: {
        breathStops: false,
        other: null,
        sleepiness: false,
        snoring: false,
        tiredness: false,
    },
    isAlcoholUser: null,
    isDrugUser: null,
    isDrugUserRemark: null,
    isPatientInformed: false,
    isSmoker: null,
    isSmokerRemark: null,
    lengthInCm: null,
    packsADaySmoked: null,
    patient: {
        ...initialAddress,
        emailAddress: null,
        homePhoneNumber: null,
        identifierSocialSecurity: null,
        mobileNumber: null,
    },
    referralReason: 'Vermoeden of uitsluiten OSAS',
    sleepRecorderType: null,
    smokingStoppedSince: null,
    weightInKg: null,
    yearsSmoked: null,
};
